import { useQuery } from "@tanstack/react-query"
import { typedEnv } from "../../config/typedEnv"

interface FontsData {
  [fontName: string]: {
    [style: string]: string[]
  }
}

type GoogleFontsCatalog = {
  [fontName: string]: {
    variants?: Record<string, Record<string, unknown>>
  }
}

// The font catalog is a static JSON on the public widget CDN. The legacy
// backend used to proxy exactly this file; the platform reads it directly.
export const useFonts = () => {
  return useQuery<FontsData, Error>({
    queryKey: ["fonts"],
    queryFn: async () => {
      const response = await fetch(`https://${typedEnv.VITE_CDN_ENDPOINT}/google-fonts.json`)
      if (!response.ok) throw new Error(`Fonts catalog request failed: ${response.status}`)

      const catalog = (await response.json()) as GoogleFontsCatalog
      const fonts: FontsData = {}
      for (const [fontName, entry] of Object.entries(catalog)) {
        const variants: { [style: string]: string[] } = {}
        for (const [style, weights] of Object.entries(entry.variants ?? {}))
          variants[style] = Object.keys(weights)
        fonts[fontName] = variants
      }
      return fonts
    },
    staleTime: 1000 * 60 * 20, // Cache the data for 20 minutes
  })
}
